import _typeof from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.timers.js";
import getParentScroll from './parentScroll';
import throttle from 'lodash-es/throttle'; // import assign from 'lodash/assign'
// import contentLoaded from './contentLoaded'

var scrollListener = {};
var pendingCheck = [];
var scrollTop, clientHeight, clientWidth;
/**
 * Call when element is onviewing
 * @param  {HTMLElement}   el [description]
 * @param  {Object}        options
 *         - visible <Boolean>      trigger "onview" only visible, default
 *         - enter   <Boolean>      trigger only on enter
 *         - once    <Boolean>      trigger once or not
 *         - offsetTop   <Number>
 *         - offsetLeft  <Number>
 * @param  {Function}      cb onview callback
 * @return {Function}      unwatch
 */

function Onview(el
/*[, options]*/
, cb) {
  var options = {};
  var args = arguments; // (el, options, cb)

  if (_typeof(cb) == 'object') {
    options = cb;
    cb = args[2];
  }

  var offsetTop = options.offsetTop || 0;
  var triggered = false,
      unbinded = false;

  function doCb() {
    if (options.once && triggered) return;
    triggered = true;
    cb();

    if (options.once) {
      unbind();
    }
  }

  bindEvent(el, 'view', doCb);

  function _handler() {
    if (options.once && triggered) return; // console.log(el);

    var rect = el.getBoundingClientRect();
    rect = {
      top: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      right: rect.right
    };

    if (rect.top === 0 && rect.bottom === 0 && rect.left === 0 && rect.right === 0) {
      triggered = false;
      return;
    }

    if (options.offsetTop) {
      rect.top += options.offsetTop; // rect.bottom += options.offsetTop;
    }

    if (options.offsetLeft) {
      rect.left += options.offsetLeft; // rect.right += options.offsetLeft;
    }

    var isInClientVertical = rect.top < 0 && rect.bottom > 0 || rect.bottom > clientHeight && rect.top < clientHeight || rect.top >= 0 && rect.bottom <= clientHeight;
    var isInClientHorizontal = rect.left < 0 && rect.right > 0 || rect.right > clientWidth && rect.left < clientWidth || rect.left >= 0 && rect.right <= clientWidth;

    if (isInClientVertical && isInClientHorizontal) {
      // console.log('in client');
      if (!triggered) {
        doCb();
      }
    } else {
      triggered = false;
    }
  }

  var parentScrollElms = getParentScroll(el);
  var scrollIds = [];
  parentScrollElms.forEach(function (parent) {
    var scrollId = parent.getAttribute('data-scrollId');

    if (!scrollId) {
      scrollId = genId();
      parent.setAttribute('data-scrollId', scrollId);
      scrollListener[scrollId] = [_handler];
      var listener = buildListener(scrollId);
      bindEvent(parent, 'scroll', listener);

      scrollListener[scrollId].unbind = function () {
        parent.removeAttribute('data-scrollId');
        unbindEvent(parent, 'scroll', listener);
        delete scrollListener[scrollId];
      };
    } else {
      scrollListener[scrollId].push(_handler);
    }

    scrollIds.push(scrollId);
    pendingCheck.push(_handler);
    check();
  });

  function unbind() {
    if (unbinded) return;
    unbinded = true;
    unbindEvent(el, 'view', doCb);
    scrollIds.forEach(function (scrollId) {
      var scrollIdListener = scrollListener[scrollId];
      var index = scrollIdListener.indexOf(_handler);

      if (index >= 0) {
        scrollIdListener.splice(index, 1);

        if (scrollIdListener.length === 0) {
          scrollIdListener.unbind();
        }
      }
    });
  }

  return unbind;
}

var check = throttle(function () {
  scrollTop = getScrollTop(), clientHeight = getClientHeight(), clientWidth = getClientWidth();
  pendingCheck.forEach(function (cb) {
    cb();
  });
  pendingCheck.length = 0;
}, 50);

var windowScroll = function windowScroll() {
  for (var scrollId in scrollListener) {
    scrollListener[scrollId].forEach(function (cb) {
      if (pendingCheck.indexOf(cb) < 0) pendingCheck.push(cb);
    });
  }

  check();
};

bindEvent(window, 'scroll', windowScroll);
bindEvent(window, 'resize', windowScroll);

function buildListener(scrollId) {
  return function (el) {
    scrollListener[scrollId].forEach(function (cb) {
      if (pendingCheck.indexOf(cb) < 0) pendingCheck.push(cb);
    });
    check();
  };
}

var id = 0;

function genId() {
  return '' + ++id;
} // function getAbsoluteOffset(el) {
//     var rect = el.getBoundingClientRect()
//     return {
//         top: rect.top + getScrollTop(),
//         left: rect.left,
//         right: rect.right,
//         bottom: rect.bottom + getScrollTop(),
//         height: rect.bottom - rect.top
//     }
// }


var ieEvent = !document.addEventListener;

function bindEvent(el, type, fn) {
  if (ieEvent) {
    el.attachEvent('on' + type, fn);
  } else {
    el.addEventListener(type, fn);
  }
}

function unbindEvent(el, type, fn) {
  if (ieEvent) {
    el.detachEvent('on' + type, fn);
  } else {
    el.removeEventListener(type, fn);
  }
}

function getScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
}

function getClientHeight() {
  if (document.compatMode == 'BackCompat') {
    return document.body.clientHeight;
  } else {
    return document.documentElement.clientHeight;
  }
}

function getClientWidth() {
  if (document.compatMode == 'BackCompat') {
    return document.body.clientWidth;
  } else {
    return document.documentElement.clientWidth;
  }
}

Onview.triggerCompute = function () {
  setTimeout(windowScroll, 0);
};

export default Onview;